const getFilterData = state  => state.filterData;
const isFilterLoading = state  => state.isFilterLoading;

const getTotalSummary = state  => state.totalSummary;
const isTotalSummaryLoading = state => state.isTotalSummaryLoading;

const getCoverageList = state  => state.coverageList;
const isCoverageListLoading = state => state.isCoverageListLoading;

const getTransition = state  => state.transition;
const isTransitionLoading = state => state.isTransitionLoading;

export default {
  getFilterData,
  isFilterLoading,
  getTotalSummary,
  isTotalSummaryLoading,
  getCoverageList,
  isCoverageListLoading,
  getTransition,
  isTransitionLoading
};



// WEBPACK FOOTER //
// ./src/store/modules/reserved/coverage/getters.js